module.exports = __webpack_public_path__ + "static/media/dnd-icon.b66bfa87.svg";